import { YouTube as YouTubeIcon } from '@mui/icons-material';
import ErrorIcon from '@mui/icons-material/Error';
import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import { LoadingButton } from '@mui/lab';
import { Box, Button, CardContent, DialogTitle, Link, ListItemIcon, Paper, useMediaQuery } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import { useTheme } from '@mui/material/styles';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CommonHelper } from 'src/utils/commonHelper';
const InstagramAuthorizationModal = (props) => {
  const { t: translate } = useTranslation();
  const theme = useTheme();
  const isCustomDomain = CommonHelper.CustomDomain();
  const isPortalAdmin = CommonHelper.GetBrandInfoFromLocalStorage("is_portal_admin");
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [isLoadingOn, setLoadingOn] = useState(false);

  const handleConnectInstagram = () => {
    setLoadingOn(true);
    props.handleConnectInstagram();
  };

  const handleClose = () => {
    props.handleClose();
  };

  return (
    <Dialog onClose={handleClose} aria-labelledby="customized-dialog-title" open>
      <DialogTitle id="customized-dialog-title" onClose={handleClose}>
        <Typography gutterBottom variant="h4">
          {props.reAuth
            ? `${translate('integration.instagram.reauthenticate_instagram_profile')}`
            : `${translate('integration.instagram.converted_instagram_to_business_profile')}`}
        </Typography>
      </DialogTitle>
      <DialogContent dividers>
        {isMobile ? (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              padding: '20px',
            }}
          >
            <Typography sx={{ fontSize: '14px', color: 'gray', marginBottom: '10px' }}>
              {translate('integration.instagram.read_our')}
              <Link
                href="https://brand2social.com/user-guides/setting-up-instagram-on-brand2social/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'blue',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  marginLeft: '5px',
                  marginRight: '5px',
                }}
              >
                {translate('integration.instagram.user_guide')}
              </Link>
              {translate('integration.instagram.step_by_step_integration')}
            </Typography>

            <Typography sx={{ fontSize: '14px', color: 'gray' }}>
              {translate('integration.instagram.watch_the_video')}
            </Typography>

            {(!isCustomDomain || isPortalAdmin) && <Button
              variant="outlined"
              startIcon={<YouTubeIcon />}
              onClick={() => window.open('https://www.youtube.com/watch?v=ER3Il2nm_W8', '_blank')}
              color="primary"
            >
              {translate('common.tutorial')}
            </Button>}
          </Box>
        ) : (
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              textAlign: 'center',
              padding: '20px',
            }}
          >
            {/* First line: User Guide */}
            <Typography sx={{ fontSize: '14px', color: 'gray', marginBottom: '10px' }}>
              {translate('integration.instagram.read_our')}
              <Link
                href="https://brand2social.com/user-guides/setting-up-instagram-on-brand2social/"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  color: 'blue',
                  textDecoration: 'none',
                  fontWeight: 'bold',
                  marginLeft: '5px',
                  marginRight: '5px',
                }}
              >
                {translate('integration.instagram.user_guide')}
              </Link>
              {translate('integration.instagram.step_by_step_integration')}
            </Typography>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <Typography sx={{ fontSize: '14px', color: 'gray' }}>
                {translate('integration.instagram.watch_the_video')}
              </Typography>
              {(!isCustomDomain || isPortalAdmin) && <Button
                variant="outlined"
                startIcon={<YouTubeIcon />}
                onClick={() => window.open('https://www.youtube.com/watch?v=ER3Il2nm_W8', '_blank')}
                color="primary"
              >
                {translate('common.tutorial')}
              </Button>}
            </Box>
          </Box>
        )}
        <CardContent sx={{ p: { xs: 0, md: 0 }, color: 'grey.800', typography: 'body1' }}>
          <Typography variant="body1" sx={{ margin: 'auto 0', fontWeight: 'bold' }}>
            {props.reAuth
              ? `${translate('common.verify_these_requirements')}:`
              : `${translate('common.make_sure_completed_steps')}:`}
          </Typography>

          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1, mt: 2 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.instagram.valid_instagram_profile')}`
                : `${translate('integration.instagram.converted_your_instagram_to_business')}`}
            </Typography>
          </Paper>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.instagram.facebook_admin_permission')}`
                : `${translate('integration.facebook.admin_of_facebook_page')}`}
            </Typography>
          </Paper>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start', mb: 1 }}>
            <ListItemIcon>
              <VerifiedUserIcon sx={{ color: 'success.dark', width: 18, height: 18, ml: 2, mt: 0.5 }} />
            </ListItemIcon>
            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.instagram.facebook_connection_with_instagram_is_valid')}`
                : `${translate('integration.instagram.facebook_permission_with_admin_permission')}`}
            </Typography>
          </Paper>
          <Paper sx={{ display: 'flex', alignItems: 'flex-start' }}>
            <ListItemIcon>
              <ErrorIcon sx={{ color: 'secondary.main', width: 20, height: 20, ml: 2, mt: 0.5 }} />
            </ListItemIcon>

            <Typography variant="body1">
              {props.reAuth
                ? `${translate('integration.instagram.review_connection_requirement')} `
                : `${translate('integration.instagram.learn_how_to_connect')} `}
              <strong>{translate('integration.instagram.instagram_account')}</strong>{' '}
              {translate('integration.instagram.with_a_facebook_page')}
              <Link
                href="https://brand2social.com/user-guides/setting-up-instagram-on-brand2social/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>
                  {props.reAuth ? `${translate('common.refresh_guide')}` : `${translate('common.click_here')}`}
                </strong>
              </Link>
            </Typography>
          </Paper>
        </CardContent>
      </DialogContent>
      <DialogActions>
        <Button color="error" variant="outlined" onClick={handleClose}>
          {translate('common.close')}
        </Button>
        <LoadingButton
          variant="contained"
          loading={isLoadingOn}
          autoFocus
          onClick={() => {
            handleConnectInstagram();
          }}
        >
          {props.reAuth ? `${translate('common.reconnect')}` : `${translate('common.connect')}`}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default InstagramAuthorizationModal;
